import React, { Component } from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import IconButton from 'material-ui/IconButton';
import { withRouter, Link } from 'react-router-dom';
import Menu, { MenuItem } from 'material-ui/Menu';
import { ListItemIcon, ListItemText } from 'material-ui/List';
import Divider from 'material-ui/Divider';
import MoreVertIcon from 'material-ui-icons/MoreVert';
import CreateIcon from 'material-ui-icons/Create';
import LoadIcon from 'material-ui-icons/CloudDownload';
import SaveIcon from 'material-ui-icons/CloudUpload';
import ExportIcon from 'material-ui-icons/FileDownload';
import ImportIcon from 'material-ui-icons/FileUpload';
import PrintIcon from 'material-ui-icons/Print';
import SettingsIcon from 'material-ui-icons/Settings'

import ExportingDialog from '../ExportingDialog';
import ImportingDialog from '../ImportingDialog';

const NEW_PATH  = '/app/new';
const SETTINGS_PATH = '/app/settings';
const REPORT_PATH = '/app/report';

export class AppMenu extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
      anchorEl: undefined,
      exportingDialogOpen: false,
      importingDialogOpen: false,
    };
    this.handleMenuClick = this.handleMenuClick.bind(this);
    this.handleMenuRequestClose = this.handleMenuRequestClose.bind(this);
    this.handleExportingDialogOpen = this.handleDialogOpen('exportingDialogOpen').bind(this);
    this.handleImportingDialogOpen = this.handleDialogOpen('importingDialogOpen').bind(this);
    this.toggle = this.toggle.bind(this);
  }

  handleMenuClick(event) {
    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  }

  handleMenuRequestClose() {
    this.setState({
      open: false,
    });
  }

  handleDialogOpen(key) {
    const that = this;
    return function() {
      that.toggle(key)();
      that.handleMenuRequestClose();
    }

  }

  toggle(key) {
    const that = this;
    return function() {
      that.setState((state) => {
        const val = state[key];
        return { [key]: !val };
      });
    };
  }

  render(){
    const {
      anchorEl,
      open,
      exportingDialogOpen,
      importingDialogOpen,
    } = this.state;
    const { location: { pathname } } = this.props;

    return (
      <div>
        <IconButton 
          color="inherit"
          data-test="menu-icon"
          onClick={this.handleMenuClick}
          aria-owns="app-menu"
          aria-haspopup="true"
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="app-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={this.handleMenuRequestClose}
        >
          <MenuItem
            disabled={pathname === NEW_PATH}
            component={Link}
            to={NEW_PATH}
            onClick={this.handleMenuRequestClose}
          >
            <ListItemIcon><CreateIcon /></ListItemIcon>
            <ListItemText inset primary="New" />
          </MenuItem>
          <MenuItem onClick={this.handleImportingDialogOpen}>
            <ListItemIcon><ImportIcon /></ListItemIcon>
            <ListItemText inset primary="Import" />
          </MenuItem>
          <MenuItem onClick={this.handleExportingDialogOpen}>
            <ListItemIcon><ExportIcon /></ListItemIcon>
            <ListItemText inset primary="Export" />
          </MenuItem>
          <MenuItem
            disabled
            onClick={this.handleMenuRequestClose}
          >
            <ListItemIcon><LoadIcon /></ListItemIcon>
            <ListItemText inset primary="Load" />
          </MenuItem>
          <MenuItem
            disabled
            onClick={this.handleMenuRequestClose}
          >
            <ListItemIcon><SaveIcon /></ListItemIcon>
            <ListItemText inset primary="Save" />
          </MenuItem>
          <MenuItem
            disabled={pathname === REPORT_PATH}
            onClick={this.handleMenuRequestClose}
            component={Link}
            to={{ pathname: REPORT_PATH, state: { from: pathname }}}
          >
            <ListItemIcon><PrintIcon /></ListItemIcon>
            <ListItemText inset primary="Report" />
          </MenuItem>
          <Divider />
          <MenuItem
            disabled={pathname === SETTINGS_PATH}
            component={Link}
            to={{ pathname: SETTINGS_PATH, state: { from: pathname }}}
            onClick={this.handleMenuRequestClose}
          >
            <ListItemIcon><SettingsIcon /></ListItemIcon>
            <ListItemText inset primary="Settings" />
          </MenuItem>
        </Menu>
        <ExportingDialog
          open={exportingDialogOpen}
          handleClose={this.toggle('exportingDialogOpen')}
        />
        <ImportingDialog
          open={importingDialogOpen}
          handleClose={this.toggle('importingDialogOpen')}
        />
      </div>
    );
  }
}

AppMenu.propTypes = {
  location:     ReactRouterPropTypes.location.isRequired,
}

export default withRouter(AppMenu);


// WEBPACK FOOTER //
// ./src/components/StackupDesign/AppMenu/AppMenu.jsx